import React, { FC, memo } from 'react'
import { Modal } from '@wmgtech/legato'

import { AlterNamesTable } from 'modules/ProjectEdit/components'

import { IAlterNamesModal } from './AlterNamesModal.props'

import './AlterNamesModal.scss'

const AlterNamesModal: FC<IAlterNamesModal> = memo(
  ({
    productId,
    productName,
    onClose,
    alterNameList,
    onDeleteAlterName,
    onCreateAlterName
  }) => (
    <Modal
      size="lg"
      className="alter-names-modal"
      isOpen={true}
      onClose={onClose}
      shouldCloseOnOverlayClick
      title={`Alternate names for ${productName}`}
    >
      <div className="alter-names-modal__body">
        <p>
          Add alternate names to match chart entries not otherwise found because of differing notations. Products match
          if any combination of name and artist matches.
        </p>
        <AlterNamesTable
          productId={productId}
          alterNamesData={alterNameList}
          onDeleteAlterName={onDeleteAlterName}
          onCreateAlterName={onCreateAlterName}
        />
        <ul>
          <li>Note: Changes may take up to 1 hour to take effect.</li>
          <li>Start typing to filter suggestions.</li>
          <li>
            Per line you can enter either artist or product. Provide a second line if you want to add both an alternate
            artist and product name.
          </li>
          <li>
            Suggestions are compiled from most recently imported chart entries across all sources. This comes with the
            restriction that products not (yet) appearing in any charts cannot be suggested. If you know the alternate
            name up front, you may enter arbitrary alternate names.
          </li>
          <li>Note that matching ignores case but preserves position, i.e.</li>
          <li>Ed Sheeran matches ED SHEERAN</li>
          <li>But Ed Sheeran does not matchSheeran, Ed</li>
          <li>To compensate for differing positions, e.g.</li>
          <li>Add artist Sheeran, Ed</li>
          <li>To match collaborations</li>
          <li>
            Add full collaboration to artist and leave product empty, e.g. artist Clean Bandit feat. Julia Michaels
          </li>
          <li>
            Add full collaboration to artist and add featured part to product in brackets, e.g. artist Clean Bandit
            feat. Julia Michaelsand product I Miss You (feat. Julia Michaels)
          </li>
          <li>Also see Feedback & Howtos.</li>
        </ul>
      </div>
    </Modal>
  )
)

export default AlterNamesModal
